export const AlarmModes = [{ key: 0, value: '←] [→' }, { key: 1, value: '[←→]' }];